const serviceData = [
    {
        id: 1,
        title: 'Flight',
        content: 'We work with the best airlines and take care of flight booking, Visa application and other travel documents.',
        iconPath: '#icon-airplane'
    },
    {
        id: 2,
        title: 'Accomodation',
        content: 'We choose the best hotels to ensure great experiences while visiting Switzerland. All hotels are rated either four or five stars.',
        iconPath: '#icon-office'
    },
    {
        id: 3,
        title: 'Food',
        content: 'All meal plans are carefully selected so that customers will be able to enjoy both local and international cuisines.',
        iconPath: '#icon-spoon-knife'
    },
    {
        id: 4,
        title: 'Transportation',
        content: 'Don’t worry about transportation when going from one place to another. We will take care of everything.',
        iconPath: '#icon-truck'
    },
    {
        id: 5,
        title: 'Tour Leader',
        content: 'Our tour leaders are experienced and professional to provide the best service the entire trip.',
        iconPath: '#icon-user-tie'
    }

];

export default serviceData;